import Api from '../../base/api.typings';
import axiosConfiguration from '../../base/axios-configuration';

class GlossarioService {
    async salvarCategoria(command: Api.App.Server.Glossario.CategoriaSalvar.Command): Promise<any> {
        await axiosConfiguration.configure();

        return axiosConfiguration.getAxios().post('/api/glossario/categoria/salvar', command);
    }

    async listarCategoria(query: Api.App.Server.Glossario.CategoriaListar.Query): Promise<Api.App.Server.Glossario.CategoriaListar.ResultadoDto> {
        await axiosConfiguration.configure();

        return axiosConfiguration.getAxios().get('/api/glossario/categoria/listar', { params: query }).then(e => e.data);
    }

    async salvarItem(command: Api.App.Server.Glossario.CategoriaSalvar.Command): Promise<any> {
        await axiosConfiguration.configure();

        return axiosConfiguration.getAxios().post('/api/glossario/salvar', command);
    }

    async listarItem(query: Api.App.Server.Glossario.ItemListar.Query): Promise<Api.App.Server.Glossario.ItemListar.ResultadoDto> {
        await axiosConfiguration.configure();

        return axiosConfiguration.getAxios().get('/api/glossario/listar', { params: query }).then(e => e.data);
    }
}

export default new GlossarioService();